var _defs, _circle, _ellipse, _circle2, _path, _circle3, _path2, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercentageConsumption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 558,
    height: 482,
    viewBox: "0 0 558 482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #0cba5f;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fea00a;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fec009;\r\n      }\r\n\r\n      .cls-10, .cls-11, .cls-12, .cls-4, .cls-7, .cls-8, .cls-9 {\r\n        fill: #6d4cb1;\r\n      }\r\n\r\n      .cls-4, .cls-6 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-10, .cls-11, .cls-12, .cls-4, .cls-5, .cls-7, .cls-8, .cls-9 {\r\n        opacity: 0.93;\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#filter);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #fff;\r\n        filter: url(#filter-2);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #7754a5;\r\n      }\r\n\r\n      .cls-7 {\r\n        filter: url(#filter-3);\r\n      }\r\n\r\n      .cls-8 {\r\n        filter: url(#filter-4);\r\n      }\r\n\r\n      .cls-9 {\r\n        filter: url(#filter-5);\r\n      }\r\n\r\n      .cls-10 {\r\n        filter: url(#filter-6);\r\n      }\r\n\r\n      .cls-11 {\r\n        filter: url(#filter-7);\r\n      }\r\n\r\n      .cls-12 {\r\n        filter: url(#filter-8);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 15,
    y: 157,
    width: 528,
    height: 176,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.646
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#553e84",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    x: 378,
    y: 209,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.646
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#553e84",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-3",
    x: 361,
    y: 389,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.646
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#553e84",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-4",
    x: 302,
    y: 434,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.646
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#553e84",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-5",
    x: 228,
    y: 443,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.646
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#553e84",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-6",
    x: 92,
    y: 56,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.646
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#553e84",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-7",
    x: 181,
    y: 23,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.646
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#553e84",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-8",
    x: 272,
    y: 13,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    result: "offset",
    dy: 3,
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 2.646
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: "#553e84",
    floodOpacity: 0.74
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    className: "cls-1",
    cx: 278,
    cy: 242,
    r: 216
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1_copia",
    "data-name": "Elipse 1 copia",
    className: "cls-2",
    cx: 278.5,
    cy: 241.719,
    rx: 176.5,
    ry: 182.719
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1_copia_2",
    "data-name": "Elipse 1 copia 2",
    className: "cls-3",
    cx: 278,
    cy: 242,
    r: 150
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    className: "cls-4",
    d: "M502.807,241.5C502.807,267.579,536,323,536,323s-114.443-18.68-257.494-18.68S21,323,21,323s33.189-55.422,33.189-81.5S21,160,21,160s114.444,18.683,257.5,18.683S536,160,536,160,502.807,215.421,502.807,241.5Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    className: "cls-5",
    cx: 414,
    cy: 242,
    r: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_",
    "data-name": "%",
    className: "cls-6",
    d: "M427.721,241.572a6.967,6.967,0,0,0-5.473-2.523,6.886,6.886,0,0,0-5.432,2.523,8.754,8.754,0,0,0,0,11.414,6.922,6.922,0,0,0,5.432,2.523,7,7,0,0,0,5.473-2.523,8.754,8.754,0,0,0,0-11.414h0ZM409.288,255.2q2.4-6.55,5.168-12.654,0.245-.53,3.215-6.531,2.806-5.717,2.807-5.778a1.476,1.476,0,0,0-.793-0.885,2.544,2.544,0,0,0-1.16-.539,0.867,0.867,0,0,0-.407.651q-1.749,4.578-2.706,6.836-1.891,4.74-2.421,5.7-6.408,12.166-6.408,12.491a1.943,1.943,0,0,0,.986.824,3.752,3.752,0,0,0,1.272.58,0.917,0.917,0,0,0,.447-0.692h0Zm1.364-23.742a7.136,7.136,0,0,0-10.9-.021,8.781,8.781,0,0,0,0,11.434,7.172,7.172,0,0,0,10.9-.02,8.792,8.792,0,0,0,0-11.393h0ZM424.1,249.405a2.139,2.139,0,0,1-1.852,1.017,2.115,2.115,0,0,1-1.81-1.058,3.543,3.543,0,0,1-.652-2.075,3.727,3.727,0,0,1,.611-2.116,2.118,2.118,0,0,1,1.851-1.058,2.1,2.1,0,0,1,1.852,1.038,3.758,3.758,0,0,1,.61,2.136,3.664,3.664,0,0,1-.61,2.116h0Zm-17.05-10.132a2.135,2.135,0,0,1-1.851,1.018,2.176,2.176,0,0,1-1.831-1.038,3.584,3.584,0,0,1-.651-2.1,3.632,3.632,0,0,1,.631-2.115A2.157,2.157,0,0,1,405.2,234a2.126,2.126,0,0,1,1.851,1.038,3.968,3.968,0,0,1,0,4.231h0Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2_copia",
    "data-name": "Elipse 2 copia",
    className: "cls-7",
    cx: 397,
    cy: 422,
    r: 30
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2_copia_2",
    "data-name": "Elipse 2 copia 2",
    className: "cls-8",
    cx: 323,
    cy: 452,
    r: 15
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2_copia_3",
    "data-name": "Elipse 2 copia 3",
    className: "cls-9",
    cx: 244,
    cy: 456,
    r: 10
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2_copia-2",
    "data-name": "Elipse 2 copia",
    className: "cls-10",
    cx: 128,
    cy: 89,
    r: 30
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2_copia_2-2",
    "data-name": "Elipse 2 copia 2",
    className: "cls-11",
    cx: 202,
    cy: 41,
    r: 15
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2_copia_3-2",
    "data-name": "Elipse 2 copia 3",
    className: "cls-12",
    cx: 288,
    cy: 26,
    r: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageConsumption);
export default __webpack_public_path__ + "static/media/percentage-consumption.1484f1a28c40fc48033c256025fe9614.svg";
export { ForwardRef as ReactComponent };